import { IReduxState } from 'types/redux';
import { LeasesStatuses, TepIntents } from 'constants/tep';

export const entryPassesSelector = (state: IReduxState) => state.veta.tep.entryPasses;

export const entryPassesErrorSelector = (state: IReduxState) => state.veta.tep.entryPasses.request.error;

export const leasesSelector = (state: IReduxState) => state.veta.tep.leases;

export const editModalSelector = (state: IReduxState) => ({
  isOpen: state.veta.tep.leases.intent === TepIntents.Edit,
  selected: state.veta.tep.leases.selected,
  ...state.veta.tep.leases.request,
});

export const draftModalSelector = (state: IReduxState) => ({
  isOpen: state.veta.tep.leases.intent === TepIntents.Draft,
  selected: state.veta.tep.leases.selected,
  ...state.veta.tep.leases.request,
});

export const issueModalSelector = (state: IReduxState) => {
  const { selectedId, selected, request } = state.veta.tep.leases;

  const selectedLease = selectedId ? selected.find(({ id }) => id === selectedId) : null;

  return { ...request, selected: selectedLease, leases: selected };
};

export const issueModalActionsSelector = (state: IReduxState) => ({
  id: state.veta.tep.leases.selectedId,
  leases: state.veta.tep.leases.selected,
});

export const officersModalSelector = (state: IReduxState) => {
  const { data, request, selectedId, intent } = state.veta.tep.officers;

  const selected = data?.find(({ id }) => id === selectedId);

  return { ...request, officers: data, selected, intent };
};

export const notifyOfficersModalSelector = (state: IReduxState) => {
  const selectedOfficersIds = state.veta.tep.officers.selected.map(({ id }) => id);
  const request = state.veta.tep.notifications.request;
  const officers = state.veta.tep.officers.data;
  const leases = state.veta.tep.leases.selected;

  return { ...request, officers, leases, selectedOfficersIds };
};

export const selectedOfficersSelector = (state: IReduxState) => ({
  selected: state.veta.tep.officers.selected,
  officers: state.veta.tep.officers.data,
});

export const leasesControlsSelector = (state: IReduxState) => {
  const count = state.veta.tep.leases.selected.length;
  let status: string | undefined;
  const statuses = state.veta.tep.leases.selected.map((lease) => lease.status);

  if (count) {
    status = new Set(statuses).size <= 1 ? statuses[0] : LeasesStatuses.Mixed;
  }

  return { count, status };
};

export const leasesCellSelector = (state: IReduxState) => ({
  id: state.veta.tep.leases.selectedId,
  intent: state.veta.tep.leases.intent,
  isRowsSelected: !!state.veta.tep.leases.selected.length,
});

export const selectedLeasesIdSelector = (state: IReduxState) => state.veta.tep.leases.selectedId;

export const selectedLeasesSelector = (state: IReduxState) => state.veta.tep.leases.selected;

export const tepCompaniesSelector = (state: IReduxState) => state.veta.tep.companies.page?.objects || [];

export const isTepCompaniesLoadingSelector = (state: IReduxState) => state.veta.tep.companies.pending;

export const selectedOfficerIdSelector = (state: IReduxState) => state.veta.tep.officers.selectedId;

export const officersCellSelector = (state: IReduxState) => ({
  id: state.veta.tep.officers.selectedId,
  intent: state.veta.tep.officers.intent,
});

export const errorModalSelector = (state: IReduxState) => {
  const error = state.veta.tep.leases.request.error;

  const isOpen = error && state.veta.tep.leases.intent === TepIntents.InlineEdit;

  return { isOpen, error };
};

export const tepTableSelector = (state: IReduxState) => state.veta.tep.leases.table;

export const officersNotificationsPageSelector = (state: IReduxState) => ({
  isLoading: state.veta.tep.notifications.request.isLoading,
  notifications: state.veta.tep.notifications.officers?.objects,
  total: state.veta.tep.notifications.officers?.total,
});

export const clientsNotificationsPageSelector = (state: IReduxState) => ({
  isLoading: state.veta.tep.notifications.request.isLoading,
  notifications: state.veta.tep.notifications.clients?.objects,
  total: state.veta.tep.notifications.clients?.total,
});

export const tepSelector = (state: IReduxState) => state.veta.tep;
